import { isWebkit } from '@/utils/detectBrowser';
import Cookie from '@/utils/cookie/index';

export default {
  name: 'head-nav',
  data() {
    return {
      activeName: 'first',
      msgList: [],
      query: {
        currentPage: 1,
        status: 0,
        pageSize: 3,
      },
      curIndex: 0,
    };
  },
  methods: {
    signOut() {
      const srcMain = Cookie.get('srcMain');
      const reg = /newRecord/;
      if (reg.test(srcMain) && isWebkit()) {
        this.$api.global.signOut().then((res) => {
          const cookieData = {
            mainIndex: 0,
            leftIndex: 0,
            srcMain: '',
            srcNav: '',
            preMainIndex: '',
          };
          for (const p in cookieData) {
            Cookie.set(p, cookieData[p]);
          }
          this.$store.commit('loginOut');
          this.$router.push({ name: 'login' });
          // location.reload();
          // window.location.href = '/';
          window.location.reload();
        });
      } else {
        this.makeUserLoginout();
      }
    },
    makeUserLoginout() {
      this.$api.global.signOut().then((res) => {
        const cookieData = {
          mainIndex: 0,
          leftIndex: 0,
          srcMain: '',
          srcNav: '',
          preMainIndex: '',
        };
        for (var p in cookieData) {
          Cookie.set(p, cookieData[p]);
        }
        this.$store.commit('loginOut');
        this.$router.push({ name: 'login' });
        // window.location.href = '/';
        window.location.reload();
      });
    },
    // 帮助中心
    toHelp() {
      this.$router.push({ name: 'help' });
    },
    // 消息列表
    toMessageList() {
      this.$router.push({ name: 'messageList' });
    },
    toMessage(id) {
      // this.$router.push({ name: 'messageDetail', query: { id } });
      const { href } = this.$router.resolve({ name: 'messageDetail', query: { id } });
      window.open(href, '_blank');
    },
    getNewMsg() {
      this.$api.global.messageList(this.query).then((res) => {
        this.msgList = res.records;
      });
    },
    hover(index) {
      this.curIndex = index;
    },
    gotoUpdatePwd() {
      this.$router.push({ name: 'updatePwd' });
    },
  },
  mounted() {
    this.getNewMsg();
  },
};
